export default __webpack_public_path__ + "static/media/grid2.7cb67109.jpg";